import { useCallback } from 'react'

import { useRouter } from 'next/router'
import useTranslation from '../../../i18n/useTranslation'

/**
 * Ringle App - target scrren names
 */
export enum ringleAppNavs {
  dialog = 'Dialog',
  cafWebview = 'CAFWebView',
  RingleWebView = 'RingleWebView',
  cafErrorReport = 'CAFErrorReport',
  cafFaq = 'CAFFaq',
  PastLessonScreen = 'PastLessonScreen',
  CreditBottomSheet = 'CreditBottomSheet',
}

interface RNMsg {
  message?: string // plain message
  nav?: ringleAppNavs
  url?: string
  title?: string // Popup Title
  detail_id?: number // caf detail id
  detail_content?: string | number // caf detail content
  sub_title?: string
  data?: string
  [key: string]: string | number
}
const useRNMsg = () => {
  const router = useRouter()
  const { locale } = useTranslation()
  const sendPostMsg = useCallback(
    (msg: RNMsg) => {
      if (window && window['ReactNativeWebView']) {
        window['ReactNativeWebView'].postMessage(JSON.stringify(msg))
      } else {
        // RN환경이 아닐 때 fallback
        if (msg.url) {
          const url = msg.url.split(`/${locale}/`)[1]
          router.push(`/${locale}/${url}`)
        }
        if (msg.message === 'pop_screen') {
          router.back()
        }
      }
    },
    [router]
  )

  const isIOS = () => {
    return navigator?.userAgent?.toLowerCase().match(/\(ip.*applewebkit(?!.*(version|crios))/)
  }

  const receivePostMsg = (callback: (res) => void) => {
    if (!window['ReactNativeWebView']) return

    if (isIOS() && typeof window !== 'undefined') {
      /** ios */
      window.addEventListener('message', (event) => callback(event.data))
    } else if (typeof document !== 'undefined') {
      /** android */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      document.addEventListener('message', (event) => callback(event.data))
    }
  }
  const removeListener = (callback: (res) => void) => {
    if (isIOS() && typeof window !== 'undefined') {
      window.removeEventListener('message', callback)
    } else if (typeof document !== 'undefined') {
      document.removeEventListener('message', callback)
    }
  }
  return { sendPostMsg, receivePostMsg, removeListener, isIOS }
}
export default useRNMsg
